import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { centsToDollars } from "legacy/helpers.es6"
import PreservedRateModalButton from "legacy/preserved_rates_table/PreservedRateModalButton"
import PropTypes from "prop-types"
import React from "react"

class PricingSection extends React.Component {
  constructor(props) {
    super(props)
    this.chargesTable = this.chargesTable.bind(this)
    this.monthlyTable = this.monthlyTable.bind(this)
    this.totalsTable = this.totalsTable.bind(this)
  }

  chargesTable() {
    if (this.props.loadingPrice) {
      return (
        <div className="h4 text-danger text-center">
          <i className="fa-kit fa-spinner fa-spin text-muted" />
        </div>
      )
    }

    if (this.props.charges && Object.keys(this.props.charges).length) {
      if (this.props.isMonthToMonth) {
        return this.monthlyTable()
      } else {
        return this.totalsTable()
      }
    }
    return null
  }

  monthlyTable() {
    return (
      <div>
        <table className="bs-mt-4 table">
          <tbody>
            {Object.entries(this.props.monthlyCharges).map(([name, total]) => (
              <tr key={name}>
                <td>{name}</td>
                <td className="text-right">{centsToDollars(total)}</td>
              </tr>
            ))}
            <tr>
              <td className="font-semibold">Monthly Total</td>
              <td className="text-right font-semibold">
                {centsToDollars(this.props.monthlyPrice)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  totalsTable() {
    return (
      <div>
        <table className="bs-mt-4 table">
          <tbody>
            {Object.entries(this.props.charges).map(([name, total]) => (
              <tr key={name}>
                <td>{name}</td>
                <td className="text-right">{centsToDollars(total)}</td>
              </tr>
            ))}
            <tr>
              <td className="font-semibold">Total</td>
              <td className="text-right font-semibold">
                {centsToDollars(this.props.totalPrice)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div
          className="bs-p-4 bs-my-5 rounded"
          style={{ backgroundColor: "#f8fafc" }}
        >
          <h4 className="bs-mt-0 font-semibold">{`${
            this.props.isMonthToMonth ? "Monthly " : ""
          }Pricing`}</h4>
          {this.props.priceErrorMessage && (
            <div className="text-danger">{this.props.priceErrorMessage}</div>
          )}
          {!this.props.priceErrorMessage && this.chargesTable()}
          <PreservedRateModalButton
            preservedRates={this.props.preservedRates}
            fullWidth={true}
          />
        </div>
        <div className="font-semibold text-teal-800">
          {this.props.billingDisplayText}
        </div>
        <FormGroup
          inputType="checkbox"
          name="confirmationEmail"
          value={this.props.confirmationEmail}
          onChange={this.props.handleInputChange}
          label={
            this.props.hasTriggerEmails
              ? "Send all automated emails to boater"
              : "Send confirmation email to boater"
          }
        />
        <NextButton
          btnClass="btn-primary w-full"
          processing={this.props.loading}
          click={this.props.submit}
          text="Create Reservation"
          processingText="Creating Reservation..."
          disabled={!!this.props.priceErrorMessage}
        />
        {this.props.createErrorMessage && (
          <div className="text-danger mt-1">
            {this.props.createErrorMessage}
          </div>
        )}
      </div>
    )
  }
}

PricingSection.propTypes = {
  billingDisplayText: PropTypes.string,
  charges: PropTypes.object,
  confirmationEmail: PropTypes.bool,
  createErrorMessage: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  hasTriggerEmails: PropTypes.bool,
  isMonthToMonth: PropTypes.bool,
  loading: PropTypes.bool,
  loadingPrice: PropTypes.bool,
  monthlyCharges: PropTypes.object,
  monthlyPrice: PropTypes.number,
  preservedRates: PropTypes.array,
  priceErrorMessage: PropTypes.string,
  submit: PropTypes.func.isRequired,
  totalPrice: PropTypes.number,
}

export default PricingSection
